import Column from '@amzn/meridian/column';
import Loader from '@amzn/meridian/loader';
import Row from '@amzn/meridian/row';
import React, { useEffect, useState } from 'react';

import App from './App';
import Auth from './Auth';
import { awsRum } from './config/cloudWatchRUM';

const AppShell: React.FC = (): React.ReactElement => {
  const [isAuthenticating, setIsAuthenticating] = useState(true);

  useEffect(() => {
    async function onLoad(): Promise<void> {
      const isAuthenticated = await Auth.isAuthenticated();
      setIsAuthenticating(!isAuthenticated);
    }
    onLoad();
  }, []);

  return isAuthenticating ? (
    <Row width='100%' widths='fill'>
      <Column
        height='500px'
        heights='fill'
        alignmentHorizontal='center'
        alignmentVertical='center'
      >
        <Loader type='circular' size='large' />
      </Column>
    </Row>
  ) : (
    <App />
  );
};

class GlobalErrorHandler extends React.Component<{
  children: React.ReactNode;
}> {
  componentDidMount(): void {
    window.addEventListener('error', this.handleError);
    window.addEventListener(
      'unhandledrejection',
      this.handleUnhandledRejection
    );
  }
  componentWillUnmount(): void {
    window.removeEventListener('error', this.handleError);
    window.removeEventListener(
      'unhandledrejection',
      this.handleUnhandledRejection
    );
  }

  componentDidCatch(error, errorInfo) {
    awsRum?.recordError(error);
  }

  handleError = (event: ErrorEvent) => {
    awsRum?.recordError(event.error);
  };

  handleUnhandledRejection = (event: PromiseRejectionEvent) => {
    if (event.reason instanceof Error) {
      awsRum?.recordError(event);
    }
  };

  render() {
    return this.props.children;
  }
}

const AppShellWithErrorHandling: React.FC = () => {
  return (
    <GlobalErrorHandler>
      <AppShell />
    </GlobalErrorHandler>
  );
};

export default AppShellWithErrorHandling;
